export default __webpack_public_path__ + "static/media/page-bg.c17f0a5a.svg";